'use client'

import React, {useEffect, useRef} from 'react'
import FamilyTypeCards from "@/app/components/healthComparator/FamilyTypeCards"
import { useHealthComparatorStore } from "@/app/stores/health/health-comparator-store"
import { useTracking } from "@/app/contexts/tracking-context"
import { HealthTrackingEnum } from "@/app/enums/HealthTrackingEnum"
import { landingHandoffUrl, resolveLandingQuoteToken } from "@/app/components/healthComparator/health-landing-handoff"

interface SelectCardProps {
    label?: string
}

export default function HealthCardChoices({
       label,
   }: SelectCardProps) {
    const { comparatorForm, originRoute } = useHealthComparatorStore()
    const { track } = useTracking()
    const profileSelectionFiredRef = useRef(false)

    const handleCardClick = (value: number) => {
        // The tokenless landing replaces the funnel's family-type step, where this event is otherwise fired.
        if (!profileSelectionFiredRef.current) {
            profileSelectionFiredRef.current = true
            track({ event: HealthTrackingEnum.ProfileSelection })
        }

        useHealthComparatorStore.setState((state) => {
            state.comparatorForm.family_type = value;
        });
    }

    useEffect(() => {
        if (comparatorForm.family_type === null) return

        const familyType = comparatorForm.family_type

        const createQuoteAndRedirect = async () => {
            const token = await resolveLandingQuoteToken(originRoute)
            if (token) {
                window.location.href = landingHandoffUrl(token, { familyType })
            }
        }

        createQuoteAndRedirect()
    }, [comparatorForm.family_type, originRoute]);

    return (
        <div>
            {label && (
                <label
                    htmlFor="card"
                    className="text-blue-700 text-base min-[1200px]:text-lg font-semibold mb-5 block"
                >
                    {label}
                </label>
            )}

            <FamilyTypeCards value={comparatorForm.family_type} onChange={handleCardClick} />
        </div>
    )
}

